import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function AutomationTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, schedulerStatus, triggerSubscriptionCheck } = ctx;

  return (
    <>
            {activeTab === 'automation' && schedulerStatus && (
              <div className="automation-content">
                <h2>Automation & Scheduler</h2>
                
                <div className="scheduler-status">
                  <div className="status-header">
                    <h3>Scheduler Status</h3>
                    <span className={`status-badge ${schedulerStatus.status}`}>
                      {schedulerStatus.status}
                    </span>
                  </div>

                  {schedulerStatus.status === 'running' && schedulerStatus.jobs && (
                    <div className="jobs-list">
                      <h4>Scheduled Jobs</h4>
                      {schedulerStatus.jobs.map((job) => (
                        <div key={job.id} className="job-card">
                          <div className="job-info">
                            <Calendar size={20} />
                            <div>
                              <div className="job-name">{job.name}</div>
                              <div className="job-next-run">
                                Next run: {job.next_run ? new Date(job.next_run).toLocaleString() : 'N/A'}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="automation-actions">
                    <h4>Manual Actions</h4>
                    <button className="btn-primary" onClick={triggerSubscriptionCheck}>
                      <RefreshCw size={20} />
                      Trigger Subscription Check Now
                    </button>
                  </div>
                </div>
              </div>
            )}
    </>
  );
}
